export type Visibility = 'public' | 'private';

export type FileType = 'PDF' | 'DOCX' | 'XLSX' | 'PPTX' | 'VIDEO' | 'IMAGE';

export interface FolderItem {
  id: string;
  name: string;
  colorId: string;
  parentId: string | null;
  owner: string;
  createdBy?: number;
  createdAt: string;
  updatedAt: string;
  visible: Visibility;
  isAdminUpload: boolean;
}

export interface LibraryFile {
  id: string;
  name: string;
  type: FileType;
  folderId: string | null;
  size: number;
  owner: string;
  createdBy?: number;
  createdAt: string;
  updatedAt: string;
  visible: Visibility;
  isAdminUpload: boolean;
}

export const FOLDER_COLORS: Record<string, { startColor: string; endColor: string }> = {
  '1': { startColor: '#FD542D', endColor: '#D62E1F' },
  '2': { startColor: '#FD8B1C', endColor: '#E56000' },
  '3': { startColor: '#E9B460', endColor: '#C8891A' },
  '4': { startColor: '#28CDFF', endColor: '#1C74FF' },
  '5': { startColor: '#A78BFA', endColor: '#7C3AED' },
  '6': { startColor: '#4ADE80', endColor: '#16A34A' },
  '7': { startColor: '#F472B6', endColor: '#DB2777' },
};

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
